import meet1Img from '../../assets/images/meet1.jpeg'
import meet2Img from '../../assets/images/meet2.jpeg'
import meet3Img from '../../assets/images/meet3.jpeg'
import meet4Img from '../../assets/images/meet4.jpeg'
import Icons from '../global/Icons'

const TeamData = [
    {
      id:1,
      title:"Devil Roy Barman",
      subTitle:"Volunteer",
      img:meet1Img,
      socialMedia: [
        {
          id: 1,
          icon: Icons.fbIcon,
          link: '#'
        },
        {
          id: 2,
          icon: Icons.linkedinIcon,
          link: '#'
        },
        {
          id: 3,
          icon: Icons.twitterIcon,
          link: '#'
        },
      ]
    },
    {
      id:2,
      title:"Devil Roy Barman",
      subTitle:"Volunteer",
      img:meet2Img,
      socialMedia: [
        {
          id: 1,
          icon: Icons.fbIcon,
          link: '#'
        },
        {
          id: 2,
          icon: Icons.linkedinIcon,
          link: '#'
        },
        {
          id: 3,
          icon: Icons.twitterIcon,
          link: '#'
        },
      ]
    },
    {
      id:3,
      title:"Devil Roy Barman",
      subTitle:"Volunteer",
      img:meet3Img,
      socialMedia: [
        {
          id: 1,
          icon: Icons.fbIcon,
          link: '#'
        },
        {
          id: 2,
          icon: Icons.linkedinIcon,
          link: '#'
        },
        {
          id: 3,
          icon: Icons.twitterIcon,
          link: '#'
        },
      ]
    },
    {
      id:4,
      title:"Devil Roy Barman",
      subTitle:"Volunteer",
      img:meet4Img,
      socialMedia: [
        {
          id: 1,
          icon: Icons.fbIcon,
          link: '#'
        },
        {
          id: 2,
          icon: Icons.linkedinIcon,
          link: '#'
        },
        {
          id: 3,
          icon: Icons.twitterIcon,
          link: '#'
        },
      ]
    },
    {
      id:5,
      title:"Devil Roy Barman",
      subTitle:"Volunteer",
      img:meet1Img,
      socialMedia: [
        {
          id: 1,
          icon: Icons.fbIcon,
          link: '#'
        },
        {
          id: 2,
          icon: Icons.linkedinIcon,
          link: '#'
        },
        {
          id: 3,
          icon: Icons.twitterIcon,
          link: '#'
        },
      ]
    },
    {
      id:6,
      title:"Devil Roy Barman",
      subTitle:"Volunteer",
      img:meet2Img,
      socialMedia: [
        {
          id: 1,
          icon: Icons.fbIcon,
          link: '#'
        },
        {
          id: 2,
          icon: Icons.linkedinIcon,
          link: '#'
        },
        {
          id: 3,
          icon: Icons.twitterIcon,
          link: '#'
        },
      ]
    },
    {
      id:7,
      title:"Devil Roy Barman",
      subTitle:"Volunteer",
      img:meet3Img,
      socialMedia: [
        {
          id: 1,
          icon: Icons.fbIcon,
          link: '#'
        },
        {
          id: 2,
          icon: Icons.linkedinIcon,
          link: '#'
        },
        {
          id: 3,
          icon: Icons.twitterIcon,
          link: '#'
        },
      ]
    },
    {
      id:8,
      title:"Devil Roy Barman",
      subTitle:"Volunteer",
      img:meet4Img,
      socialMedia: [
        {
          id: 1,
          icon: Icons.fbIcon,
          link: '#'
        },
        {
          id: 2,
          icon: Icons.linkedinIcon,
          link: '#'
        },
        {
          id: 3,
          icon: Icons.twitterIcon,
          link: '#'
        },
      ]
    },
    {
        id:9,
        title:"Devil Roy Barman",
        subTitle:"Volunteer",
        img:meet1Img,
        socialMedia: [
          {
            id: 1,
            icon: Icons.fbIcon,
            link: '#'
          },
          {
            id: 2,
            icon: Icons.linkedinIcon,
            link: '#'
          },
          {
            id: 3,
            icon: Icons.twitterIcon,
            link: '#'
          },
        ]
      },
      {
        id:10,
        title:"Devil Roy Barman",
        subTitle:"Volunteer",
        img:meet2Img,
        socialMedia: [
          {
            id: 1,
            icon: Icons.fbIcon,
            link: '#'
          },
          {
            id: 2,
            icon: Icons.linkedinIcon,
            link: '#'
          },
          {
            id: 3,
            icon: Icons.twitterIcon,
            link: '#'
          },
        ]
      },
      {
        id:11,
        title:"Devil Roy Barman",
        subTitle:"Volunteer",
        img:meet3Img,
        socialMedia: [
          {
            id: 1,
            icon: Icons.fbIcon,
            link: '#'
          },
          {
            id: 2,
            icon: Icons.linkedinIcon,
            link: '#'
          },
          {
            id: 3,
            icon: Icons.twitterIcon,
            link: '#'
          },
        ]
      },
      {
        id:12,
        title:"Devil Roy Barman",
        subTitle:"Volunteer",
        img:meet4Img,
        socialMedia: [
          {
            id: 1,
            icon: Icons.fbIcon,
            link: '#'
          },
          {
            id: 2,
            icon: Icons.linkedinIcon,
            link: '#'
          },
          {
            id: 3,
            icon: Icons.twitterIcon,
            link: '#'
          },
        ]
      },
      {
        id:13,
        title:"Devil Roy Barman",
        subTitle:"Volunteer",
        img:meet1Img,
        socialMedia: [
          {
            id: 1,
            icon: Icons.fbIcon,
            link: '#'
          },
          {
            id: 2,
            icon: Icons.linkedinIcon,
            link: '#'
          },
          {
            id: 3,
            icon: Icons.twitterIcon,
            link: '#'
          },
        ]
      },
      {
        id:14,
        title:"Devil Roy Barman",
        subTitle:"Volunteer",
        img:meet2Img,
        socialMedia: [
          {
            id: 1,
            icon: Icons.fbIcon,
            link: '#'
          },
          {
            id: 2,
            icon: Icons.linkedinIcon,
            link: '#'
          },
          {
            id: 3,
            icon: Icons.twitterIcon,
            link: '#'
          },
        ]
      },
      {
        id:15,
        title:"Devil Roy Barman",
        subTitle:"Volunteer",
        img:meet3Img,
        socialMedia: [
          {
            id: 1,
            icon: Icons.fbIcon,
            link: '#'
          },
          {
            id: 2,
            icon: Icons.linkedinIcon,
            link: '#'
          },
          {
            id: 3,
            icon: Icons.twitterIcon,
            link: '#'
          },
        ]
      },
      {
        id:16,
        title:"Devil Roy Barman",
        subTitle:"Volunteer",
        img:meet4Img,
        socialMedia: [
          {
            id: 1,
            icon: Icons.fbIcon,
            link: '#'
          },
          {
            id: 2,
            icon: Icons.linkedinIcon,
            link: '#'
          },
          {
            id: 3,
            icon: Icons.twitterIcon,
            link: '#'
          },
        ]
      },
      {
        id:17,
        title:"Devil Roy Barman",
        subTitle:"Volunteer",
        img:meet1Img,
        socialMedia: [
          {
            id: 1,
            icon: Icons.fbIcon,
            link: '#'
          },
          {
            id: 2,
            icon: Icons.linkedinIcon,
            link: '#'
          },
          {
            id: 3,
            icon: Icons.twitterIcon,
            link: '#'
          },
        ]
      },
      {
        id:18,
        title:"Devil Roy Barman",
        subTitle:"Volunteer",
        img:meet2Img,
        socialMedia: [
          {
            id: 1,
            icon: Icons.fbIcon,
            link: '#'
          },
          {
            id: 2,
            icon: Icons.linkedinIcon,
            link: '#'
          },
          {
            id: 3,
            icon: Icons.twitterIcon,
            link: '#'
          },
        ]
      },
      {
        id:19,
        title:"Devil Roy Barman",
        subTitle:"Volunteer",
        img:meet3Img,
        socialMedia: [
          {
            id: 1,
            icon: Icons.fbIcon,
            link: '#'
          },
          {
            id: 2,
            icon: Icons.linkedinIcon,
            link: '#'
          },
          {
            id: 3,
            icon: Icons.twitterIcon,
            link: '#'
          },
        ]
      },
      {
        id:20,
        title:"Devil Roy Barman",
        subTitle:"Volunteer",
        img:meet4Img,
        socialMedia: [
          {
            id: 1,
            icon: Icons.fbIcon,
            link: '#'
          },
          {
            id: 2,
            icon: Icons.linkedinIcon,
            link: '#'
          },
          {
            id: 3,
            icon: Icons.twitterIcon,
            link: '#'
          },
        ]
      },
      {
        id:21,
        title:"Devil Roy Barman",
        subTitle:"Volunteer",
        img:meet1Img,
        socialMedia: [
          {
            id: 1,
            icon: Icons.fbIcon,
            link: '#'
          },
          {
            id: 2,
            icon: Icons.linkedinIcon,
            link: '#'
          },
          {
            id: 3,
            icon: Icons.twitterIcon,
            link: '#'
          },
        ]
      },
      {
        id:22,
        title:"Devil Roy Barman",
        subTitle:"Volunteer",
        img:meet2Img,
        socialMedia: [
          {
            id: 1,
            icon: Icons.fbIcon,
            link: '#'
          },
          {
            id: 2,
            icon: Icons.linkedinIcon,
            link: '#'
          },
          {
            id: 3,
            icon: Icons.twitterIcon,
            link: '#'
          },
        ]
      },
      {
        id:23,
        title:"Devil Roy Barman",
        subTitle:"Volunteer",
        img:meet3Img,
        socialMedia: [
          {
            id: 1,
            icon: Icons.fbIcon,
            link: '#'
          },
          {
            id: 2,
            icon: Icons.linkedinIcon,
            link: '#'
          },
          {
            id: 3,
            icon: Icons.twitterIcon,
            link: '#'
          },
        ]
      },
      {
        id:24,
        title:"Devil Roy Barman",
        subTitle:"Volunteer",
        img:meet4Img,
        socialMedia: [
          {
            id: 1,
            icon: Icons.fbIcon,
            link: '#'
          },
          {
            id: 2,
            icon: Icons.linkedinIcon,
            link: '#'
          },
          {
            id: 3,
            icon: Icons.twitterIcon,
            link: '#'
          },
        ]
      }

  ]

export default TeamData;